import { createFileRoute } from '@tanstack/react-router'
import { MoltenGoldSettingsPage } from '@/features/molten-gold/components/molten-gold-settings-page'

export const Route = createFileRoute('/_authenticated/molten-gold-settings/')({
  component: MoltenGoldSettingsPage,
})
